import type { ReactElement } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '../stores/auth.js';

/**
 * A client-side guard is a convenience, not a control — the API checks the
 * token on every request. This only avoids rendering screens that would turn
 * up empty.
 */
export default function RequireSession({ children }: { children: ReactElement }): ReactElement {
  const user = useAuthStore((s) => s.user);
  const location = useLocation();

  if (!user) return <Navigate to="/signin" state={{ from: location.pathname }} replace />;
  return children;
}
